import "./SwipeableModals.scss";
import React, { useEffect, useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api";
import { toast } from "react-toastify";

// Common styles for InputLabel to reduce repetition
const commonLabelStyles = {
  background: "white",
  transformOrigin: "right top",
  transform: "translate(14px, -9px) scale(0.75)",
  right: 24,
  left: "auto",
  paddingLeft: "4px",
  paddingRight: "4px",
};

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  initialData = null,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    titleAr: "",
    titleEn: "",
    textAr: "",
    textEn: "",
  });

  // Set initial form data if editing
  useEffect(() => {
    if (initialData && currentView === "editTerm") {
      setFormData({
        titleAr: initialData.titleAr || "",
        titleEn: initialData.titleEn || "",
        textAr: initialData.textAr || "",
        textEn: initialData.textEn || "",
      });
    } else {
      // Reset form data for creation
      setFormData({
        titleAr: "",
        titleEn: "",
        textAr: "",
        textEn: "",
      });
    }
  }, [initialData, currentView]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (currentView === "createTerm") {
        await api.post("/system/terms-conditions", formData);
        toast.success("تم إضافة الشروط بنجاح");
      } else if (currentView === "editTerm") {
        await api.put(`/system/terms-conditions/${initialData._id}`, formData);
        toast.success("تم تحديث الشروط بنجاح");
      }

      if (refreshData) {
        refreshData();
      }
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "حدث خطأ ما");
    } finally {
      setFormData({
        titleAr: "",
        titleEn: "",
        textAr: "",
        textEn: "",
      });
      setIsLoading(false);
    }
  };

  const renderTermForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "editTerm" ? "تعديل الشروط" : "اضافة شرط جديد"}
      </p>
      <form onSubmit={handleSubmit}>
        {/* Title in Arabic */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="title-ar" shrink sx={commonLabelStyles}>
            عنوان النص بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="title-ar"
            type="text"
            value={formData.titleAr}
            onChange={(e) =>
              setFormData({
                ...formData,
                titleAr: e.target.value,
              })
            }
          />
        </FormControl>

        {/* Title in English */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="title-en" shrink sx={commonLabelStyles}>
            عنوان النص بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="title-en"
            type="text"
            value={formData.titleEn}
            onChange={(e) =>
              setFormData({
                ...formData,
                titleEn: e.target.value,
              })
            }
          />
        </FormControl>

        {/* Content in Arabic */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="content-ar" shrink sx={commonLabelStyles}>
            النص بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="content-ar"
            type="text"
            multiline
            minRows={5}
            value={formData.textAr}
            onChange={(e) =>
              setFormData({
                ...formData,
                textAr: e.target.value,
              })
            }
          />
        </FormControl>

        {/* Content in English */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="content-en" shrink sx={commonLabelStyles}>
            النص بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="content-en"
            type="text"
            multiline
            minRows={5}
            value={formData.textEn}
            onChange={(e) =>
              setFormData({
                ...formData,
                textEn: e.target.value,
              })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "editTerm" ? "تحديث" : "اضافة"}
          size="medium"
          variant="fill"
          loading={isLoading}
          type="submit"
        />
      </form>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    createTerm: renderTermForm,
    editTerm: renderTermForm,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
